export default __webpack_public_path__ + "static/N0278-21e4c568a89e0e4baf64fa7b1f3fc2bf.png";